import gql from "graphql-tag";

export default gql`query QuotesInstructed($date:Date!) {
    quotesDiary(instructed:1, date:$date) {
        id
        name
        instructed
        total
        totalClass
        telephone
        timestamp
        addressBooksByType(types:[3,4]) {
            id
            archived
            entity {
                id
                name
                type{
                    id
                    name            
                }                
            }
        }
        files{
          id
          referencelong  
          department {
              id
          }   
        }
        quoteType{
          id
          abbreviation
        }
        quoteEmails {
            email {
                id
                address
                entity {
                    id
                }
            }
        }
        referrer {
            id
            name
        }
        user {
            id
            name
        }
        logCount
      }
  }`